/**
 * 環境判定ユーティリティ
 * 開発環境、検証環境、本番環境を判定し、認証方式を決定
 */

export const getEnvironment = () => {
  const envMode = process.env.REACT_APP_ENVIRONMENT_MODE;
  if (envMode) {
    const normalized = envMode.toLowerCase();
    if (normalized === 'dev' || normalized === 'development') return 'development';
    if (normalized === 'test' || normalized === 'tst') return 'test';
    if (normalized === 'stg' || normalized === 'staging') return 'staging';
    if (normalized === 'prod' || normalized === 'production') return 'production';
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('.test.') || hostname.includes('.test-') || hostname.endsWith('.test')) {
      return 'test';
    }
    if (hostname.includes('.stg.') || hostname.includes('.staging-') || hostname.endsWith('.staging')) {
      return 'staging';
    }
    if (hostname.includes('.prod.') || hostname.includes('.production-') || hostname.endsWith('.prod')) {
      return 'production';
    }
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    }
  }

  const projectId = process.env.REACT_APP_GOOGLE_CLOUD_PROJECT || '';
  if (projectId.includes('prod') || projectId === 'quick-win-prod') {
    return 'production';
  }
  if (projectId.includes('test') || projectId === 'quick-win-test' || projectId === 'sej-prd-dx-test') {
    return 'test';
  }
  if (projectId.includes('stg') || projectId.includes('staging')) {
    return 'staging';
  }

  return 'development';
};

export const isDevelopment = () => getEnvironment() === 'development';

export const isTestOrStaging = () => {
  const env = getEnvironment();
  return env === 'test' || env === 'staging';
};

export const isProduction = () => getEnvironment() === 'production';

/**
 * SSO認証を使用するか。開発環境では常に false。
 */
export const shouldUseSSOAuth = () => {
  if (isDevelopment()) {
    return false;
  }

  const enableSSO = process.env.REACT_APP_ENABLE_SSO_AUTH;
  if (enableSSO !== undefined) {
    return enableSSO === 'true';
  }

  return isTestOrStaging() || isProduction();
};
